import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { Select } from '@app/lib/inputs/Select'

export const CourtCaseNameSelect = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  const options = [
    {
      value: 'AG',
      label: formatMessage({ id: 'CourtCases.Invoicing.Option.Court.AG' })
    },
    {
      value: 'LG',
      label: formatMessage({ id: 'CourtCases.Invoicing.Option.Court.LG' })
    },
    {
      value: 'OLG',
      label: formatMessage({ id: 'CourtCases.Invoicing.Option.Court.OLG' })
    },
    {
      value: 'BGH',
      label: formatMessage({ id: 'CourtCases.Invoicing.Option.Court.BGH' })
    }
  ]

  return (
    <InputField
      name='CourtCaseName'
      className={b('field', { lg: true })}
      label={formatMessage({ id: 'CourtCases.Invoicing.Field.CourtName' })}
      render={({ inputProps }) => {
        return (
          <Select
            {...inputProps}
            triggerSize='sm'
            placeholder={formatMessage({
              id: 'CourtCases.Invoicing.Field.CourtName.Placeholder'
            })}
            options={options}
          />
        )
      }}
    />
  )
}
